'use strict';

/** @type {import('./pow')} */
module.exports = Math.pow;



//////////////////
// WEBPACK FOOTER
// ./~/react-router/~/math-intrinsics/pow.js
// module id = 5632
// module chunks = 0